import { CSSProperties } from "react";

const MTE_SM = 480;
const MTE_MD = 720;

/**
 * Returns the modal border radius based on device type
 * Mobile devices: 0
 * Desktop/Laptop: 24
 */
export const getBorderRadius = (): number => {
    const userAgent = navigator?.userAgent?.toLowerCase();
    const isMobileUA = /iphone|ipad|ipod|android|webos|blackberry|windows phone/i.test(userAgent);
    const hasTouchScreen = 'ontouchstart' in window || navigator?.maxTouchPoints > 0;
    
    const isMobile = isMobileUA || hasTouchScreen;
    
    return isMobile ? 0 : 24;
}

export const screenSizes: { id: string, size: number }[] = [
    {
        id: "MTE_SM",
        size: MTE_SM,
    },
    {
        id: "MTE_MD",
        size: MTE_MD,
    },
]

/**
 * When the width is smaller than 
 * 
 */
export const minWidthMatcher = (): string => {
    for (let i = 0; i < screenSizes.length; i++) {
        const { id, size } = screenSizes[i];
        if (window.matchMedia(`(min-width: ${size}px`).matches) {
            return id
        }
    }
    return "ANY"
}

export const containerStyle: CSSProperties = {
    paddingRight: 0,
    paddingLeft: 0,
    marginRight: "auto",
    marginLeft: "auto",
    maxHeight: 812
}

export const containerMediaStyles: { [id: string]: CSSProperties } = {
    MTE_SM: {
        width: 480
    },
    MTE_MD: {
        width: 720
    },
    ANY: {
        width: "100%",
        height: "100%",
        maxWidth: "100%",
        maxHeight: "100%"
    },
}

export const appWrapperStyle: CSSProperties = {
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 999999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100vw",
    height: CSS.supports("height: 100dvh") ? "100dvh" : window.innerHeight + "px",
    maxHeight: CSS.supports("height: 100dvh") ? "100dvh" : window.innerHeight + "px",
    background: "rgba(0,0,0,0.5)",
    cursor: "pointer"
}

export const modalStyle: CSSProperties = {
    padding: 0,
    backgroundColor: "#FFF",
    height: "calc(100% - 100px)",
    maxWidth: "calc(100% - 30px)",
    borderRadius: getBorderRadius()
}

export const iframeWrapperStyle: CSSProperties = {
    width: "100%",
    height: "100%",
    border: "none",
    overflow: "hidden"
};

export const iframeStyle: CSSProperties = {
    width: "100%",
    height: "100%",
    border: "none",
    margin: 0,
    padding: 0,
    overflow: "hidden",
    borderRadius: getBorderRadius(),
};